<template>
    <MiscLink
        v-for="product in products"
        :key="product.id"
        :to="formatLink(getProductRoute(product))"
        class="flex justify-between items-center gap-4 focus:outline-outline-focus"
        :title="product.name"
        tabindex="0"
    >
        <div class="w-12 h-12">
            <NuxtImg
                v-if="product.media?.[0]?.media?.path != null"
                :src="product.media?.[0]?.media?.path"
                :alt="product.media?.[0]?.media?.alt"
                :placeholder="'/images/loader.gif'"
                quality="60"
                width="48"
                height="48"
                loading="lazy"
            />
            <img
                v-else
                src="/images/placeholder-image.png"
                alt="Placeholder"
                width="48"
                data-not-lazy
            >
        </div>
        <div class="w-full flex justify-between items-center gap-4 py-3 border-b">
            <div class="text-sm flex-shrink mr-auto">
                <div class="font-bold">
                    {{ product.name }}
                </div>
                <div v-if="product.manufacturer" class="text-base-content-subtle">
                    {{ product.manufacturer.name }}
                </div>
            </div>
            <SearchResultPrice :product="product" />
            <MiscIcon name="chevron-right" class="shrink-0" />
        </div>
    </MiscLink>
</template>

<script setup lang="ts">
import type { Schemas } from '#shopware'
import { getProductRoute } from "@shopware/helpers"

const props = defineProps<{
    products: Schemas['Product'][],
    currentRefinement: string,
    resultsQuery: string
}>()

const localePath = useLocalePath()
const { formatLink } = useInternationalization(localePath)
const nuxtApp = useNuxtApp()

// To dedup tracking for product changes in between searches 
let lastTrackedSignature: string | undefined
watch(() => props.products, (newVal) => {
    if (!newVal || newVal.length === 0 || props.resultsQuery !== props.currentRefinement) return

    const signature = newVal.map(product => product.id).join('|')
    if (signature === lastTrackedSignature) return
    lastTrackedSignature = signature

    nuxtApp.callHook('viewProductListing', {
        id: 'a4g_search_api_autocomplete',
        name: 'A4G Search API Autocomplete',
        products: newVal
    })
}, { immediate: true })
</script>
